// Skeleton primitive — single rectangle with pulsing opacity.
// Each screen assembles primitives into a layout that mirrors its real content,
// so the transition to fetched data is visually continuous (no spinner→layout shift).
import type { JSX } from 'preact';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  style?: JSX.CSSProperties;
}

export function Skeleton({
  width = '100%',
  height = 14,
  borderRadius = 6,
  style = {},
}: SkeletonProps) {
  return (
    <div
      class="skeleton"
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
        ...style,
      }}
    />
  );
}
